import React, { useCallback, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { folderVariables } from './data'
import Condition from '../../Condition'

export default function FolderConditions({ control }) {
  const bumper = useState(new Date().getTime())
  const setTimestamp = bumper[1]

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'conditions',
    keyName: 'key',
  })

  const onAddCondition = useCallback(
    () => {
      const newCondition = {
        operator: null,
        param: null,
        value: '',
      }
      append(newCondition)
      setTimestamp(new Date().getTime())
    },
    [append, setTimestamp]
  )

  const onRemoveCondition = useCallback(
    (condition, index) => {
      remove(index)
      setTimestamp(new Date().getTime())
    },
    [remove, setTimestamp]
  )

  const onConditionChange = useCallback(
    (newCondition, index) => {
      update(index, newCondition)
    },
    [update]
  )

  return (
    <>
      <div className="grui pt-10">
        {fields.map((item, index) => (
          <Condition
            // eslint-disable-next-line react/no-array-index-key
            key={`condition-${item.id}-${index}`}
            variables={folderVariables}
            index={index}
            onRemoveCondition={onRemoveCondition}
            conditionId={item.id}
            conditionParam={item.param}
            conditionOperator={item.operator}
            conditionValue={item.value}
            onConditionChange={onConditionChange}
            onInput={onConditionChange}
          />
        ))}
      </div>
      <div className="grui mt-10">
        <button
          type="button"
          css={[
            button.styles.link,
            text.styles.textSm,
            text.styles.textPrimary,
          ]}
          onClick={onAddCondition}
        >
          + Add condition
        </button>
      </div>
    </>
  )
}
